import React, { useState, useEffect, useRef } from 'react';

function formatBold(str) {
  if (!str) return "";
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  const textWithLinks = str.replace(urlRegex, url =>
    `<a href="${url}" target="_blank" rel="noopener noreferrer" style="color: #00bfff; text-decoration: underline;">${url}</a>`
  );
  return textWithLinks.replace(/\*([^*]+)\*/g, '<b>$1</b>');
}

const ChatGPTTypingEffect = ({
  messages = [],
  typingSpeed = 30,
  pauseBetween = 1000,
  onTypingStart = () => {},   // ✅ NEW
  onMessageTyped = () => {},
  onComplete = () => {},
  style = {},
  className = '',
}) => {
  const [displayedMessages, setDisplayedMessages] = useState([]);
  const [currentLine, setCurrentLine] = useState('');
  const [msgIndex, setMsgIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);
  const startedRef = useRef(false); // ✅ Track if typing start callback fired

  const defaultStyle = {
    color: '#0A0A0A',
    fontSize: '15px',
    whiteSpace: 'pre-wrap',
    fontWeight:'400'
  };
  

  useEffect(() => {
    if (msgIndex >= messages.length) {
      onComplete();
      return;
    }

    const currentMessage = messages[msgIndex];

    // ✅ Fire onTypingStart only once per message
    if (!startedRef.current) {
      onTypingStart(currentMessage, msgIndex);
      startedRef.current = true;
    }

    if (charIndex < currentMessage.length) {
      const timeout = setTimeout(() => {
        setCurrentLine((prev) => prev + currentMessage[charIndex]);
        setCharIndex((prev) => prev + 1);
      }, typingSpeed);
      return () => clearTimeout(timeout);
    } else {
      const pause = setTimeout(() => {
        setDisplayedMessages((prev) => [...prev, currentMessage]);
        onMessageTyped(currentMessage, msgIndex);
        setCurrentLine('');
        setMsgIndex((prev) => prev + 1);
        setCharIndex(0);
        startedRef.current = false; // ✅ Reset for next message
      }, pauseBetween);
      return () => clearTimeout(pause);
    }
  }, [charIndex, msgIndex, messages, typingSpeed, pauseBetween]);

  return (
    <div className={className} style={{...defaultStyle, ...style }}>
      {displayedMessages.map((msg, i) => (
        <div
          key={i}
          dangerouslySetInnerHTML={{ __html: formatBold(msg) }}
        />
      ))}
      {currentLine && (
        <div
          dangerouslySetInnerHTML={{ __html: formatBold(currentLine) }}
        />
      )}
    </div>
  );
};

export default ChatGPTTypingEffect;
